<template>
  <div class="audio-realtime-content" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column prop="name" :label="$t('broadcast.task_name')"> </el-table-column>
        <el-table-column prop="terminalNumber" :label="$t('broadcast.device_id')"> </el-table-column>
        <el-table-column prop="volume" :label="$t('broadcast.volume')"> </el-table-column>
        <el-table-column prop="times" :label="$t('broadcast.cycles_number')" width="160"></el-table-column>
        <el-table-column prop="edit" :label="$t('broadcast.media_list')" width="220" align="center">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="(dialogMediaList = true), mediaListBox(scope.row.id)"
              round
            >
              <font v-if="scope.row.ste">{{$t('control.edit')}}</font>
              <font v-else>{{$t('control.set')}}</font>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('broadcast.cycles_number')" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="(dialogTimes = true), openTimesWin(scope.row)"
              round
              >{{$t('control.set')}}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column :label="$t('broadcast.volume')" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="(dialogVolume = true), openVolumeWin(scope.row)"
              round
              >{{$t('control.set')}}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column :label="$t('broadcast.play_music')" width="240" align="center">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="StartMusic(scope.row)"
              round
              >{{$t('control.play')}}</el-button
            >
            <el-button
              size="small"
              type="info"
              @click="OverMusic(scope.row)"
              round
              >{{$t('control.close')}}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      custom-class="mw-edit-dialog"
      class="dialog600"
      :title="editType === 'create' ? $t('broadcast.add_task') : $t('broadcast.edit_task')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item :label="$t('broadcast.task_name')" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>

          <el-form-item :label="$t('broadcast.select_device')" prop="terminal_number_arr">
            <el-select
              :placeholder="$t('broadcast.select_device')"
              multiple
              v-model="editOne.terminal_number_arr"
              style="width: 100%"
            >
              <el-option
                v-for="t in devSelect"
                :key="t.value"
                :label="t.label"
                :value="t.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('broadcast.volume')" prop="volume">
            <el-input-number
              v-model="editOne.volume"
              size="small"
              :min="0"
              :max="100"
              :step="5"
            ></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('control.frequency')" prop="times">
            <el-input-number
              v-model="editOne.times"
              size="small"
              :min="1"
            ></el-input-number>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>

    <!--设置音量-->
    <el-dialog
      class="dialog400"
      v-if="dialogVolume"
      :title="$t('broadcast.set_volume')"
      :visible.sync="dialogVolume"
    >
      <el-form
        :model="editVolume"
        label-position="left"
        label-width="80px"
        :rules="editVolumeRule"
        ref="setVolume"
      >
        <el-form-item :label="$t('broadcast.volume')" prop="volume">
          <el-input v-model="editVolume.volume"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVolume = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button type="primary" @click="setVolume"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>

    <!--设置循环次数-->
    <el-dialog
      class="dialog400"
      v-if="dialogTimes"
      :title="$t('broadcast.set_cycles')"
      :visible.sync="dialogTimes"
    >
      <el-form
        :model="editTimes"
        label-position="left"
        label-width="80px"
        :rules="editTimeRule"
        ref="timesForm"
      >
        <el-form-item :label="$t('broadcast.cycles_number')" prop="times">
          <el-input v-model="editTimes.times"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTimes = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button type="primary" @click="setTimes"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>

    <!--设置媒体库-->
    <el-dialog
      v-if="dialogMediaList"
      :title="$t('broadcast.music_list')"
      :visible.sync="dialogMediaList"
    >
      <dalog-media-list :nowId="nowId"></dalog-media-list>
    </el-dialog>
  </div>
</template>

<script>
import autoListApi from "@/api/audio/audioList";
import realtimeApi from "@/api/audio/realtime";
import dalogMediaList from '@/components/audio/realtime/dalogMediaList.vue'
export default {
  components:{ 
    dalogMediaList
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogVolume: false,
      dialogTimes: false,
      dialogMediaList: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,

      nowId: Number,
      editOneRule: {
        name: [{ required: true, message: this.$t('broadcast.enter_task_name'), trigger: "blur" }],
      },
      editVolumeRule: {
        volume: [{ required: true, message: this.$t('broadcast.enter_volume'), trigger: "blur" }],
      },
      editTimeRule: {
        times: [
          {
            required: true,
            message: this.$t('broadcast.enter_cycles_number'),
            trigger: "blur",
          }
        ],
      },
      editType: -1,
      cnt_all: 0,
      pages: {
        page: 1,
        pageSize: 10,
      },
      devSelect: [],
      editOne: {
        name: "",
        volume: 0,
        times: 0,
        terminal_number: "",
        terminal_number_arr: [],
      },
      editVolume: {
        task_id: null,
        volume: 0,
      },
      editTimes: {
        task_id: null,
        times: 0,
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取任务列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      realtimeApi.realtimeList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.audioDeviceList();
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val
      this.getTableData(this.pageInfo.page)
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val
      this.getTableData(this.pageInfo.page)
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: "",
          volume: 0,
          times: 0,
          terminal_number: "",
          terminal_number_arr: [],
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          volume: index.volume,
          times: index.times,
          terminal_number: index.terminalNumber,
          terminal_number_arr: [],
        };
        this.editType = "update"
      }
      this.dialogVisible = true;
    },
    openVolumeWin(index) {
      //设置音量
      this.editVolume.task_id = index.id;
      this.editVolume.volume = index.volume;
      this.dialogVolume = true;
    },
    openTimesWin(index) {
      //设置循环次数
      this.editTimes.task_id = index.id;
      this.editTimes.times = index.times;
      this.dialogTimes = true;
    },
    mediaListBox(index) {
      //弹出列表
      this.dialogMediaList = true;
      this.nowId = index;
    },
    updateItem() {
      // console.log('updateItem',this.editOne)
      let devId_arr = this.editOne.terminal_number_arr;
      let devId_str;
      if (devId_arr.length < 2) {
        devId_str = devId_arr[0] + "|";
      } else {
        devId_str = devId_arr.join("|");
      }
      this.editOne.terminal_number = devId_str;
      //音频名
      realtimeApi.realtimeEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {

      let devId_arr = this.editOne.terminal_number_arr;
      let devId_str;
      if (devId_arr.length < 2) {
        devId_str = devId_arr[0] + "|";
      } else {
        devId_str = devId_arr.join("|");
      }
      this.editOne.terminal_number = devId_str;

      realtimeApi.realtimeAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
      .then(() => {
        realtimeApi.realtimeDel(id).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success(this.$t('control.del_success'));
            this.getTableData(this.pageInfo.page);
          } else {
            this.$message.error(res.data.message);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: this.$t('control.cancel_del'),
        });
      });
    },



    StartAudioLive(id) {
      this.$post("StartAudioLive", { id: id }).then((resp) => {
        // console.log(res.data);
        if (res.data.code === 1000) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    OverAudioLive(id) {
      this.$post("OverAudioLive", { id: id }).then((resp) => {
        // console.log(res.data)
        if (res.data.code === 1000) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    setVolume() {
      this.$refs["setVolume"].validate((valid) => {
        if (valid) {
          realtimeApi.realtimeSetVolume(this.editVolume).then((res) => {
            this.$message.success(res.data.message);
            if (res.data.code === 1000) {
              this.dialogVolume = false;
              this.getTableData(this.pageInfo.page);
            }
          });
        }
      });
    },

    setTimes() {
      this.$refs["timesForm"].validate((valid) => {
        if (valid) {
          realtimeApi.realtimeSetTimes(this.editTimes).then((res) => {
            this.$message.success(res.data.message);
            if (res.data.code === 1000) {
              this.dialogTimes = false;
              this.getTableData(this.pageInfo.page);
            }
          });
        }
      });
    },

    StartMusic(row) {
      realtimeApi.realtimeSetOn({
        task_id: row.id
      }).then((res) => {
        this.$message.success(res.data.message);
        if (res.data.code === 1000) {
          this.getTableData(this.pageInfo.page);
        }
      });
    },
    OverMusic(row) {
      realtimeApi.realtimeSetClose({
        task_id: row.id
      }).then((res) => {
        this.$message.success(res.data.message);
        if (res.data.code === 1000) {
          this.getTableData(this.pageInfo.page);
        }
      });
    },

    audioDeviceList() {
      // 获取所有的网络广播
      autoListApi
        .audioList({
          page: 1,
          pageSize: 200,
        })
        .then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data.list;
            let devData = [];
            for (let i = 0; i < resData.length; i++) {
              let devobj = {
                value: resData[i].terminal_number,
                label:resData[i].terminal_number + "[" + resData[i].lamp_name + "]",
              };
              devData[i] = devobj;
            }
            this.devSelect = devData;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less'>
.audio-realtime-content {
  width: 100%;
  .form-info{
    padding-left:5px;
    padding-right: 0;
    .el-form-item__label{
      width:105px;
    }
  }
}
</style>